import { Player } from "@lottiefiles/react-lottie-player";
import { Box, createStyles, makeStyles, Typography } from "@material-ui/core";
import { useState } from "react";
import { FareastButton } from "./OverlayComponentButton";
import { Check } from "@material-ui/icons";
import { useAppSelector } from "../reduxhooks";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(() =>
    createStyles({
        textAtas: {
            textAlign: "center",
        },
        title: {
            fontWeight: 600,
            fontSize: "1.2rem",
            marginBottom: "8px",
        },
        keterangan: {
            fontSize: ".75rem",
            color: "#8a8a8aff",
            marginBottom: "8px",
        },
        spanKeterangan: {
            fontWeight: 500,
            textDecoration: "underline",
            textUnderlineOffset: "4px",
        },
        idLapor: {
            fontSize: "1.1rem",
            color: "#8a8a8aff",
            marginBottom: "5vh",
        },
        addressBox: {
            borderRadius: "15px",
            padding: "10px",
            marginBottom: "15px",
            border: "1px solid #8a8a8aff",
        },
        nomorDanSalin: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "12px",
        },
    })
);

export default function Confirmation() {
    const classes = useStyles();
    const [isCopied, setIsCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText("Studio S.\nJalan Alamanda X, Blok I 10 No. 16, Jelupang,\nSerpong Utara 15323\n\n087813028340");
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 3000);
    };
    const history = useHistory();
    const timestamp = useAppSelector((state) => state.serviceTicketState.serviceTicketObject.timestamp);

    return (
        <Box>
            <Player key="done-animation" autoplay loop src="https://studiosclo.uk/general/Lottie_Done_Loop.json" style={{ height: "174px", marginTop: "15px", marginBottom: "8px" }}></Player>
            <Box className={classes.textAtas}>
                <Typography className={classes.title}>Tiket Bantuan Dibuat</Typography>
                <Typography className={classes.keterangan}>
                    Laporan kamu diterima, kirim produk yang diajukan ke alamat tertera dan <span className={classes.spanKeterangan}>upload bukti resi pengiriman</span> untuk diproses lebih lanjut oleh tim kami.
                </Typography>
                <Typography className={classes.idLapor}>ID LAPOR</Typography>
            </Box>
            <Box>
                <Typography className={classes.title} style={{ fontSize: "1.1rem", marginBottom: "0" }}>
                    Pengiriman Produk
                </Typography>
                <Typography className={classes.keterangan}>Kirim produk ke alamat berikut ini</Typography>
                <Box className={classes.addressBox}>
                    <Typography style={{ fontWeight: 600, fontSize: "0.9rem" }}>Studio S.</Typography>
                    <Typography style={{ fontSize: "0.9rem" }}>
                        Jalan Alamanda X, Blok I 10 No. 16, Jelupang,
                        <br />
                        Serpong Utara 15323
                    </Typography>
                    <Box className={classes.nomorDanSalin}>
                        <Typography style={{ fontSize: "0.9rem" }}>087813028340</Typography>
                        <FareastButton
                            buttonMarginLeftRight="0px"
                            buttonMarginTopBottom="0px"
                            onClick={handleCopy}
                            style={{
                                height: "25px",
                            }}
                        >
                            {isCopied ? <Check fontSize="small" /> : "SALIN"}
                        </FareastButton>
                    </Box>
                </Box>
                <Box style={{ width: "100%", textAlign: "right" }}>
                    <FareastButton
                        buttonMarginLeftRight="5px"
                        buttonMarginTopBottom="10px"
                        style={{
                            height: "40px",
                        }}
                        onClick={() => {
                            history.push(`/service-ticket/${timestamp}`);
                        }}
                    >
                        UPLOAD RESI
                    </FareastButton>
                </Box>
            </Box>
        </Box>
    );
}
